<script setup>
import {computed} from "vue";
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import {useI18n} from "vue-i18n";

const store    = useStore();
const router   = useRouter();
const {locale} = useI18n({useScope: "global"})

const project = computed(() => store.state.projectInfo ?? null);
const model   = computed(() => store.state.currentModel);

const isAuthenticated = computed(() => {
  return store.getters.isAuthenticated
});

function logout() {
  store.dispatch('logout')
  router.push({name: 'HomeView'});
}

</script>

<template>
  <v-app-bar app color="surface-light">
    <div class="project-title">
      <h3 v-if="project !== undefined && project !== null">{{ project.name }}</h3>
      <h5 v-if="model !== undefined && model !== null">{{ $t('model').capitalize() }}: {{ model.name }}</h5>
    </div>
    <v-spacer></v-spacer>
    <div class="nav-locale-changer">
      <v-select v-model="locale"
                :items="$i18n.availableLocales"
                variant="underlined"
                min-width="55"
      ></v-select>
    </div>

    <div v-if="store.getters.userAgent === 'desktop' && isAuthenticated">
      <b>{{ store.state.user.name }}</b>
      <span style="margin-left: 8px;"></span>
      <span v-if="store.state.user.role === 'manufacturer'">
        {{ $t('manufacturerAccess') }}
      </span>
      <span v-else-if="store.state.user.role === 'admin'">
        {{ $t('adminAccess') }}
      </span>
      <span v-else-if="store.state.user.role === 'architect'">
        {{ $t('architectAccess') }}
      </span>
      <span v-else-if="store.state.user.role === 'carbonmanager'">
        {{ $t('carbonManagerAccess') }}
      </span>
      <span v-else-if="store.state.user.role === 'structure'">
        {{ $t('structureAccess') }}
      </span>
      <span v-else-if="store.state.user.role === 'costmanager'">
        {{ $t('costManagerAccess') }}
      </span>
    </div>

    <v-btn outlined v-if="!isAuthenticated" @click="store.dispatch('redirectToAuth')">
      <span>{{ $t('speckleLogin') }}</span>
    </v-btn>

    <v-btn outlined v-else @click="logout">
      <v-icon size="28" class="mr-1">mdi-account-circle</v-icon>
      {{ $t('logout') }}
    </v-btn>

  </v-app-bar>
  <v-divider opacity="0.75" thickness="2" color="secondary"></v-divider>
</template>

<style scoped>
@import '@/assets/styles/components/AppBar.css';
</style>